<div class="radio-widget-selection">
  <div>{{label}}</div>
  <div class="options">
    <div *ngFor="let option of options" class="option" [class.selected]="option === selectedOption" (click)="selectOption(option)">
      <div class="radio" [class.selected]="option === selectedOption"><div class="inner"></div></div>
      <div class="content">
        <span class="title">{{option.title}}</span>
        <span class="text">{{option.text}}</span>
      </div>
    </div>
  </div>
</div>